<template>
  <div class="report_wrap">
    <div class="report_img">
      <div class="img_tit">内容中心</div>
    </div>
    <div class="realize_nav_wrap">
      <el-row class="realize_nav" type="flex" justify="center">
        <el-col
          v-for="(tag, index) in tagList"
          :key="index"
          class="realize_item"
          :class="activeIndex === index ? 'active' : ''"
          :span="4"
          :xs="8"
          @click.native="changeTab(index + '')"
        >
          <div class="nav_top">{{ tag.txt }}</div>
          <div class="nav_bottom"></div>
        </el-col>
      </el-row>
    </div>
    
    <!-- 列表页 -->
    <div v-if="!currentArticle" class="report_content">
      <div class="report_tag_wrap hidden-xs-only">
        <span>热门标签：</span>
        <Tag 
          v-for="(tag, index) in tagList" 
          :key="index"
          :name="index" 
          color="blue" 
          checkable 
          :checked="tag.isSelect"
          size="large"
          @on-change="changeSelectTag"
        >
          {{ tag.txt }}
        </Tag>
      </div>
      <div class="book_list">
        <div v-if="bookList.length > 0" class="masonry-container">
          <div 
            v-for="(item, index) in bookList" 
            :key="index"
            class="book_item"
            @click="showDetail(item)"
          >
            <div class="book_cover">
              <img :src="item.front_path" :alt="item.report_name" />
            </div>
            <div class="book_info">
              <h3 class="title">{{ item.report_name }}</h3>
              <p class="author">作者：{{ item.author }}</p>
              <p class="intro">{{ item.introduction }}</p>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <i class="el-icon-document"></i>
          <p>暂无相关报告</p>
        </div>
      </div>
      <div class="total-count">
        共<span>{{ bookList.length }}</span>条信息
      </div>
    </div>

    <!-- 详情页 -->
    <div v-else class="article_content">
      <div class="article_container">
        <div class="nav-header">
          <div class="back_btn" @click="closeDetail">
            <i class="el-icon-arrow-left"></i>
            返回列表
          </div>
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>内容中心</el-breadcrumb-item>
            <el-breadcrumb-item>{{ currentArticle.report_name }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="article_header">
          <h1 class="article_title">{{ currentArticle.report_name }}</h1>
          <div class="article_meta">
            <span>作者：{{ currentArticle.author }}</span>
            <span class="separator">|</span>
            <span>发布时间：{{ formatDate(currentArticle.publishTime) }}</span>
          </div>
        </div>
        <div class="article_body" v-html="currentArticle.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from '@better-scroll/core'
import Pullup from '@better-scroll/pull-up'
import MouseWheel from '@better-scroll/mouse-wheel'
BScroll.use(Pullup)
BScroll.use(MouseWheel)

export default {
  data() {
    return {
      tagList: [
        {
          isSelect: true,
          txt: '医药健康',
          categoryId: 5
        },
        {
          isSelect: false,
          txt: '公司资讯',
          categoryId: 6
        }
      ],
      bookList: [],
      activeIndex: 0,
      pageNo: 1,
      pageSize: 10,
      total: 0,
      currentArticle: null
    }
  },
  created() {
    this.getArticleList()
  },
  methods: {
    changeSelectTag(checked, name) {
      this.activeIndex = name
      this.tagList.map((v, i) => {
        if (name === i) {
          v.isSelect = checked
        } else {
          v.isSelect = false
        }
      })
      this.currentArticle = null // 切换标签时回到列表页
      this.getArticleList()
    },
    async getArticleList() {
      const params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        categoryId: this.tagList[this.activeIndex].categoryId
      }

      const res = await this.axios.get(
        '/admin-api/system/article/page',
        {
          params,
          headers: {
            'tenant-id': '1',
            'authorization': 'Bearer test1'
          }
        }
      )
      if (res.data.code === 0) {
        this.bookList = res.data.data.list.map(item => ({
          front_path: item.picUrl,
          report_name: item.title,
          id: item.id,
          author: item.author,
          introduction: item.introduction,
          content: item.content,
          publishTime: item.createTime
        }))
        this.total = res.data.data.total
      }
    },
    showDetail(article) {
      this.currentArticle = article
    },
    closeDetail() {
      this.currentArticle = null
    },
    changeTab(name) {
      this.activeIndex = parseInt(name)
      this.pageNo = 1
      this.currentArticle = null // 切换tab时回到列表页
      this.getArticleList()
    },
    formatDate(dateStr) {
      if (!dateStr) return '暂无';
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
  },
}
</script>

<style lang="scss" scoped>
// 定义主色调变量
$primary-color: #2091d3;
$primary-hover: darken($primary-color, 10%);
$primary-light: rgba($primary-color, 0.1);

.report_wrap {
      .report_img {
      width: 100%;
      height: 500PX;
      background: url('../../assets/img/aboutbg.054cc8b.jpg') center center no-repeat;
      background-size: cover;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;

      @media screen and (max-width: 768PX) {
        height: 400PX;
        min-height: 200PX;
      }

      .img_tit {
        font-size: 40PX;
        padding: 0 20PX;

        @media screen and (max-width: 768PX) {
          font-size: 24PX;
          padding: 0 15PX;
        }
      }
    
    @media screen and (max-width: 768PX) {
      height: 40vh;
      min-height: 200PX;
    }

    .img_tit {
      font-size: 40PX;
      font-weight: bold;
      text-align: center;
      padding: 0 20PX;
      max-width: 1200PX;
      line-height: 1.4;
      
      @media screen and (max-width: 768PX) {
        font-size: 22PX;
      }
    }
  }

  .realize_nav_wrap {
    position: sticky;
    top: 0;
    z-index: 10;
    background: #fff;
    box-shadow: 0 2PX 8PX rgba(0, 0, 0, 0.1);

    .realize_nav {
      max-width: 1200PX;
      margin: 0 auto;

      .realize_item {
        text-align: center;
        cursor: pointer;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .nav_top {
          padding: 25PX 0;
          font-size: 18PX;
          color: #666;
          transition: all 0.3s ease;
          letter-spacing: 1PX;
          line-height: 1;

          @media screen and (max-width: 768PX) {
            padding: 15PX 0;
            font-size: 15PX;
          }
        }

        .nav_bottom {
          height: 4PX;
          width: 40PX;
          background: transparent;
          transition: all 0.3s ease;
          border-radius: 2PX;
          margin-top: -4PX;
        }

        &:hover .nav_top {
          color: $primary-color;
        }

        &.active {
          .nav_top {
            color: $primary-color;
            font-weight: 600;
          }
          .nav_bottom {
            background: $primary-color;
            box-shadow: 0 2PX 6PX rgba($primary-color, 0.3);
          }
        }
      }
    }
  }

  .report_content {
    padding: 40PX 0;
    max-width: 1200PX;
    margin: 0 auto;

    .report_tag_wrap {
      max-width: 1200PX;
      margin: 0 auto 40PX;
      padding: 0 20PX;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      position: relative;

      span {
        color: #333;
        margin-right: 20PX;
        font-size: 16PX;
        font-weight: 500;
        height: 40PX;
        line-height: 40PX;
      }

      :deep(.ivu-tag) {
        margin: 4PX 8PX;
        padding: 0 16PX;
        cursor: pointer;
        transition: all 0.3s ease;
        border-radius: 20PX;
        font-size: 14PX;
        background: #fff;
        border: 1PX solid #e8e8e8;
        color: #666;
        height: 32PX;
        line-height: 30PX;
        display: inline-flex;
        align-items: center;
        justify-content: center;

        &:hover {
          transform: translateY(-2PX);
          box-shadow: 0 4PX 12PX rgba(0, 0, 0, 0.1);
          border-color: $primary-color;
          color: $primary-color;
        }

        &.ivu-tag-checked {
          background: #fff;
          color: $primary-color;
          border-color: $primary-color;
          font-weight: 500;

          &:hover {
            transform: translateY(-2PX);
          }
        }

        @media screen and (max-width: 768PX) {
          padding: 0 12PX;
          font-size: 13PX;
          margin: 3PX 6PX;
          height: 28PX;
          line-height: 26PX;
        }
      }
    }

    .total-count {
      color: #666;
      font-size: 13PX;
      text-align: right;
      padding: $spacing-sm;
      span {
        color: $primary-color;
        padding: 0 4PX;
        font-weight: 600;
        font-size: 14PX;
        margin: 0;
        height: auto;
        line-height: normal;
      }
    }

    .book_list {
      max-width: 1200PX;
      margin: 0 auto;
      padding: 0 20PX;

      .empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 80PX 0;
        color: #909399;

        i {
          font-size: 48PX;
          margin-bottom: 20PX;
          color: $primary-color;
          opacity: 0.8;
        }

        p {
          font-size: 16PX;
        }

        @media screen and (max-width: 768PX) {
          padding: 60PX 0;

          i {
            font-size: 36PX;
            margin-bottom: 15PX;
          }

          p {
            font-size: 14PX;
          }
        }
      }

      .masonry-container {
        column-count: 3;
        column-gap: 30PX;
        padding: 0 15PX;
        
        @media screen and (max-width: 1200PX) {
          column-count: 2;
          column-gap: 25PX;
        }
        
        @media screen and (max-width: 768PX) {
          column-count: 1;
          column-gap: 20PX;
          padding: 0 10PX;
        }

        .book_item {
          break-inside: avoid;
          margin-bottom: 30PX;
          background: #fff;
          border-radius: 12PX;
          overflow: hidden;
          box-shadow: 0 2PX 12PX rgba(0, 0, 0, 0.08);
          transition: all 0.3s ease;
          cursor: pointer;

          &:hover {
            transform: translateY(-5PX);
            box-shadow: 0 8PX 24PX rgba(0, 0, 0, 0.12);

            .book_cover img {
              transform: scale(1.05);
            }

            .title {
              color: $primary-color;
            }
          }

          .book_cover {
            width: 100%;
            overflow: hidden;
            
            img {
              width: 100%;
              height: auto;
              transition: transform 0.3s ease;
            }
          }

          .book_info {
            padding: 20PX;

            @media screen and (max-width: 768PX) {
              padding: 15PX;
            }

            .title {
              font-size: 18PX;
              font-weight: 600;
              color: #333;
              margin-bottom: 12PX;
              line-height: 1.4;

              @media screen and (max-width: 768PX) {
                font-size: 16PX;
                margin-bottom: 8PX;
              }
            }

            .author {
              font-size: 14PX;
              color: #666;
              margin-bottom: 10PX;

              @media screen and (max-width: 768PX) {
                font-size: 13PX;
                margin-bottom: 8PX;
              }
            }

            .intro {
              font-size: 14PX;
              color: #999;
              line-height: 1.6;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              overflow: hidden;

              @media screen and (max-width: 768PX) {
                font-size: 13PX;
                line-height: 1.5;
                -webkit-line-clamp: 2;
              }
            }
          }
        }
      }
    }
  }
}

.article_content {
  background: #fff;
  min-height: 400PX;
  padding: 40PX 0;

  .article_container {
    max-width: 1200PX;
    margin: 0 auto;
    padding: 0 40PX;
    
    @media screen and (max-width: 768PX) {
      padding: 0 20PX;
    }

    .nav-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 40PX;
      flex-wrap: wrap;
    }

    .back_btn {
      display: inline-flex;
      align-items: center;
      color: $primary-color;
      font-size: 16PX;
      cursor: pointer;
      transition: all 0.3s ease;

      i {
        margin-right: 5PX;
        font-size: 18PX;
      }

      &:hover {
        color: $primary-hover;
      }
    }

    .el-breadcrumb {
      font-size: 14PX;
    }

    .article_header {
      margin-bottom: 40PX;
      padding-bottom: 20PX;
      border-bottom: 1PX solid #eee;

      .article_title {
        font-size: 28PX;
        font-weight: 600;
        color: #333;
        margin-bottom: 20PX;
        line-height: 1.4;

        @media screen and (max-width: 768PX) {
          font-size: 20PX;
        }

        &:hover {
          color: $primary-color;
        }
      }

      .article_meta {
        color: #999;
        font-size: 14PX;

        .separator {
          margin: 0 10PX;
        }
      }
    }

    .article_body {
      font-size: 16PX;
      line-height: 1.8;
      color: #333;

      @media screen and (max-width: 768PX) {
        font-size: 14PX;
      }

      :deep() {
        img {
          max-width: 100%;
          height: auto;
          margin: 20PX 0;
          border-radius: 4PX;
        }

        p {
          margin-bottom: 1em;
          text-align: justify;
        }

        h1, h2, h3, h4, h5, h6 {
          margin: 1.5em 0 1em;
          font-weight: 600;
          color: #333;
        }
      }
    }
  }
}
</style>